export default __webpack_public_path__ + "static/media/icon-zalo.b383d1aa.svg";